var _defs, _path, _circle, _circle2, _rect, _rect2, _rect3, _circle3, _circle4, _text, _path2, _text2, _text3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgClosedSign = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 800,
  height: 640
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "closed-sign_svg__a",
  x1: 0,
  x2: 0,
  y1: 0,
  y2: 1
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#2F80ED"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#1E6FD9"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#5B6B80",
  strokeLinecap: "round",
  strokeWidth: 6,
  d: "M400 60 190 210M400 60l210 150"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 400,
  cy: 60,
  r: 16,
  fill: "#8A97A8"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 400,
  cy: 60,
  r: 8,
  fill: "#C9D2DD"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 584,
  height: 360,
  x: 112,
  y: 212,
  fill: "#0B2A55",
  opacity: 0.18,
  rx: 36
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 600,
  height: 360,
  x: 100,
  y: 196,
  fill: "url(#closed-sign_svg__a)",
  stroke: "#154FA0",
  strokeWidth: 6,
  rx: 36
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 544,
  height: 304,
  x: 128,
  y: 224,
  fill: "none",
  stroke: "#EAF2FF",
  strokeDasharray: "2 14",
  strokeLinecap: "round",
  strokeWidth: 5,
  rx: 22
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 190,
  cy: 210,
  r: 9,
  fill: "#154FA0"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 610,
  cy: 210,
  r: 9,
  fill: "#154FA0"
})), _text || (_text = /*#__PURE__*/React.createElement("text", {
  x: 400,
  y: 300,
  fill: "#EAF2FF",
  fontFamily: "DejaVu Sans",
  fontSize: 44,
  fontWeight: "bold",
  letterSpacing: 10,
  textAnchor: "middle"
}, "MAAF")), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EAF2FF",
  strokeWidth: 3,
  d: "M250 325h300",
  opacity: 0.6
})), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
  x: 400,
  y: 405,
  fill: "#FFF",
  fontFamily: "DejaVu Sans",
  fontSize: 64,
  fontWeight: "bold",
  textAnchor: "middle"
}, "KAMI TUTUP")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
  x: 400,
  y: 475,
  fill: "#EAF2FF",
  fontFamily: "DejaVu Sans",
  fontSize: 28,
  textAnchor: "middle"
}, "Aplikasi ini sudah tidak tersedia")));
export default SvgClosedSign;